package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter6.getRecapImperfettivoQuiz
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_tema_verbale_sdm_f_1
import gero.composeapp.generated.resources.exp_content_il_tema_verbale_sdm_f_2
import gero.composeapp.generated.resources.exp_content_il_tema_verbale_sdm_f_3
import gero.composeapp.generated.resources.exp_content_il_tema_verbale_sdm_f_4
import gero.composeapp.generated.resources.exp_title_il_tema_verbale_sdm_f

fun getIlTemaVerbaleSdmFContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_tema_verbale_sdm_f,
            content = Res.string.exp_content_il_tema_verbale_sdm_f_1,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_tema_verbale_sdm_f,
            content = Res.string.exp_content_il_tema_verbale_sdm_f_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_tema_verbale_sdm_f,
            content = Res.string.exp_content_il_tema_verbale_sdm_f_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_tema_verbale_sdm_f,
            content = Res.string.exp_content_il_tema_verbale_sdm_f_4,
            face = Faces.Sad,
            character = Characters.Nilo,
        )
    )
}

fun getIlTemaVerbaleSdmFQuizContent(
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String
): List<IQuizContent> {
    return getRecapImperfettivoQuiz(words, verbs, languageCode)
}
